window.addEventListener('load', () => {
  const legendElement = document.querySelector('.main_search_label');
  if (legendElement && legendElement.tagName.toLowerCase() === 'legend') {
    const labelElement = document.createElement('label');
    labelElement.className = legendElement.className;
    labelElement.innerHTML = legendElement.innerHTML;
    legendElement.parentNode.replaceChild(labelElement, legendElement);
  }
  const divDivider = document.createElement('div');
  divDivider.style.width = '100%';

  const imgDesktop = document.createElement('img');
  imgDesktop.className = 'n-desktop';
  imgDesktop.style.width = '100%';
  imgDesktop.src = 'https://cdn.shopify.com/s/files/1/0656/2027/9543/files/Line_1_42bb7b76-ad1a-4fa7-963b-2a2d3cdc284f.png?v=1731534352';
  imgDesktop.alt = '';

  const imgMobile = document.createElement('img');
  imgMobile.className = 'n-mobile';
  divDivider.style.width = '100%';
  imgMobile.src = 'https://cdn.shopify.com/s/files/1/0656/2027/9543/files/Line_1_42bb7b76-ad1a-4fa7-963b-2a2d3cdc284f.png?v=1731534352';
  imgMobile.alt = '';

  divDivider.appendChild(imgDesktop);
  divDivider.appendChild(imgMobile);

  const searchOptions = document.querySelector('.search_options');
  if (searchOptions) {
    searchOptions.appendChild(divDivider);
  }

  const app = document.querySelector('.show-addresses');
  if (app) {
    old_add_markers = add_markers;
    add_markers = function() {
      mainIcon = "https://cdn.shopify.com/s/files/1/0656/2027/9543/files/Pin_1.png?v=1731529251";
      youIcon = "https://cdn.shopify.com/s/files/1/0656/2027/9543/files/Pin_1.png?v=1731529251";
      add_markers = old_add_markers;
      add_markers();
    }
  }
});
